// 統一語意色彩（含灰色、背景等）
export const semanticColors = {
  grayText: '#666',
  lightBg: '#f8f9fa',
};
export default semanticColors;
